const ROOT = 'UNIT_EDIT_PAYMENT_DETAILS_';

const actions = {
  LOAD_FORM_INFO_REQUEST: `${ROOT}LOAD_FORM_INFO_REQUEST`,
  LOAD_FORM_INFO_SUCCESS: `${ROOT}LOAD_FORM_INFO_SUCCESS`,
  LOAD_FORM_INFO_ERROR: `${ROOT}LOAD_FORM_INFO_ERROR`,
  LOAD_PAYMENT_SETTINGS_REQUEST: `${ROOT}LOAD_PAYMENT_SETTINGS_REQUEST`,
  LOAD_PAYMENT_SETTINGS_SUCCESS: `${ROOT}LOAD_PAYMENT_SETTINGS_SUCCESS`,
  LOAD_PAYMENT_SETTINGS_ERROR: `${ROOT}LOAD_PAYMENT_SETTINGS_ERROR`,
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  UPDATE_PAYMENT_DETAILS_REQUEST: `${ROOT}UPDATE_PAYMENT_DETAILS_REQUEST`,
  UPDATE_PAYMENT_DETAILS_SUCCESS: `${ROOT}UPDATE_PAYMENT_DETAILS_SUCCESS`,
  UPDATE_PAYMENT_DETAILS_ERROR: `${ROOT}UPDATE_PAYMENT_DETAILS_ERROR`,
} as const;

export default actions;
